/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the 
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
module.exports = {
	EXPECTED_SEPARATOR: 100,
	EXPECTED_EXPRESSION: 101,
	EXPECTED_BRACKET_LEFT: 102,
	EXPECTED_BRACKET_RIGHT: 103,
	EXPECTED_QUOTE: 104,
	MISSING_OPERAND: 300,
	UNEXPECTED_CHAR: 500,
	UNKNOWN_FUNCTION: 1000,
	UNKNOWN_IDENTIFIER: 1001
};
